import { Writing } from "../types";
import { ComputeFieldComponent } from "../computeFields";
import { t } from "i18next";
import { SeparatedList } from "./shared/utils";

export const EcritSummaryCF: ComputeFieldComponent<
  Pick<
    Writing,
    | "ecritsDescriptionTitre"
    | "ecritsDescriptionType"
    | "ecritsDescriptionCopyright"
    | "ecritsDescriptionDate"
    | "ecritsDescriptionLieuDeCreation"
    | "ecritsDescriptionPhotographe"
  >
> = ({ input, language, ...props }) => {
  return (
    <SeparatedList
      {...props}
      language={language}
      commaSeparated={false}
      input={[
        <SeparatedList
          {...props}
          endWithPeriod
          language={language}
          input={[
            input.ecritsDescriptionTitre,
            input.ecritsDescriptionLieuDeCreation?.trim()
              ? input.ecritsDescriptionLieuDeCreation
              : t("computeField.sansLieuAbbrege", { lng: language }),
            input.ecritsDescriptionDate?.trim()
              ? input.ecritsDescriptionDate
              : t("computeField.sansDateAbbrege", { lng: language }),
          ]}
        />,
        <SeparatedList
          {...props}
          commaSeparated={false}
          language={language}
          input={[
            input.ecritsDescriptionType && `- ${input.ecritsDescriptionType}`,
            input.ecritsDescriptionPhotographe?.trim() &&
              `${t("computeField.photoCredit", { lng: language })} : ${input.ecritsDescriptionPhotographe}`,
            input.ecritsDescriptionCopyright &&
              `© ${input.ecritsDescriptionCopyright}`,
          ]}
        />,
      ]}
    />
  );
};
